
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Home",
      function () {
        return require("private-next-pages/Home/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Home"])
      });
    }
  